// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signatures .signatures__description {\n  margin-bottom: 20px;\n}\n.signatures .page-data-table__cell----pending {\n  color: #34c0cc;\n}\n.signatures .page-data-table__cell----approved {\n  color: var(--color-primary);\n  color: var(--color-secondary);\n}\n.signatures .page-data-table__cell----rejected {\n  color: #ff3369;\n}\n.signatures__tab--active {\n  border-bottom: 5px solid #3f43ad;\n}\n", ""]);
// Exports
module.exports = exports;
